import Vue from 'vue'
import App from './App.vue'
import {
  BootstrapVue
} from "bootstrap-vue";
import axios from 'axios'
import VueAxios from 'vue-axios'
import Vuelidate from 'vuelidate'
// import VueCardFormat from 'vue-credit-card-validation';

import router from './router'

Vue.config.productionTip = false
Vue.use(BootstrapVue);
Vue.use(VueAxios, axios);
Vue.use(Vuelidate);
// Vue.use(VueCardFormat);

  
new Vue({
  router,
  render: h => h(App)
}).$mount('#app')
